import { createFileRoute, redirect } from "@tanstack/react-router";

// Nothing lives at /: the dashboard's boundary sends a visitor without a session to /login.
export const Route = createFileRoute("/(public)/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard" });
  },
});
